export default "__VITE_ASSET__DahKdtv8__$_?component__"